module.exports = __webpack_public_path__ + "77b610384e28c366f9671a34d4abf286.svg";